export const typeErrorServer = 'Ha ocurrido un error con el servidor';
export const stateIntent = 'Intención de envío';
export const stateSuccessful = 'Envío exitoso';
export const notAvailable = 'Not available';
